import { JsonDatePipe } from './../pipes/json-date.pipe';
import { Artikel, ArtikelResponse } from './../classes/artikel';
import { ModalController, NavParams } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { getConfig } from '../classes/getConfig/getConfig';
import { DataService } from './../services/data.service';
import { Kondition, Shop } from '../classes/login';
import { Config } from './../classes/config';

@Component({
  selector: 'app-shop-order',
  templateUrl: './shop-order.page.html',
  styleUrls: ['./shop-order.page.scss'],
})
export class ShopOrderPage implements OnInit {
  public artikelRes: ArtikelResponse = null;
  public warenwert: number;
  public einheiten: number;
  public bemerkung = '';
  public shop: Shop = null;
  public kondition: Kondition = null;
  public lieferdatum: Date = null;
  public config: Config;
  public ccs = 0;
  public preisAnzeigen = true;

  constructor(public navParams: NavParams, public modalCtrl: ModalController, public data: DataService) {
    this.artikelRes = navParams.data.artikelRes;
    this.warenwert = navParams.data.warenwert;
    this.einheiten = navParams.data.einheiten;
    this.ccs = navParams.data.ccs;
    this.lieferdatum = navParams.data.lieferdatum;
    this.shop = navParams.data.shop;
    this.kondition = navParams.data.kondition;
    this.config = getConfig();

    if (this.artikelRes.artikel.length > 0) {
      this.preisAnzeigen = this.artikelRes.artikel[0].preisAnzeigen;
    }
  }

  ngOnInit() {
  }

  checkMax(item: Artikel) {
    if (item.pos.eh > item.maxEh) {
      item.pos.eh = item.maxEh;
    }
  }

  updateWarenkorb(item: Artikel) {
    this.data.setWarenkorb(this.shop.nr, this.kondition.name, item);
  }

  calcWarenwert() {
    this.warenwert = 0;
    this.einheiten = 0;
    this.ccs = 0;
    if (this.artikelRes.artikel !== null && this.artikelRes.artikel !== undefined) {
      for (let j = 0; j < this.artikelRes.artikel.length; j++) {
        const artikel: Artikel = this.artikelRes.artikel[j];
        // this.preisAnzeigen = artikel.preisAnzeigen;  // FRA_210701: Funktioniert hier nicht??
        artikel.vkPreis = artikel.vkPreisVe;
        if (artikel.pos.eh * artikel.multiplikator >= artikel.ehPLage) {
          artikel.vkPreis = artikel.vkPreisLg;
        }
        if (artikel.pos.eh * artikel.multiplikator >= artikel.ehPLage * artikel.lgPCC) {
          artikel.vkPreis = artikel.vkPreisCc;
        }
        if (!this.artikelRes.nochNichtLieferbareAnzeigen || this.lieferbar(artikel)) {
          this.warenwert += artikel.vpe * artikel.vkPreis * artikel.pos.eh * artikel.multiplikator;
          this.einheiten += artikel.pos.eh * artikel.multiplikator;
          this.ccs += 1 / (artikel.ehPLage * artikel.lgPCC) * artikel.pos.eh * artikel.multiplikator;
        }
        if (artikel.hatSorten) {
          for (let k = 0; k < artikel.sorten.length; k++) {
            const sorte: Artikel = artikel.sorten[k];
            sorte.vkPreis = sorte.vkPreisVe;
            if (sorte.pos.eh * sorte.multiplikator >= sorte.ehPLage) {
              sorte.vkPreis = sorte.vkPreisLg;
            }
            if (sorte.pos.eh * sorte.multiplikator >= sorte.ehPLage * sorte.lgPCC) {
              sorte.vkPreis = sorte.vkPreisCc;
            }
            if (!this.artikelRes.nochNichtLieferbareAnzeigen || this.lieferbar(sorte)) {
              this.warenwert += sorte.vpe * sorte.vkPreis * sorte.pos.eh * sorte.multiplikator;
              this.einheiten += sorte.pos.eh * sorte.multiplikator;
              this.ccs += 1 / (sorte.ehPLage * sorte.lgPCC) * sorte.pos.eh * sorte.multiplikator;
            }
          }
        }
      }
    }
    this.ccs = Math.round(this.ccs * 10) / 10;
  }

  ok() {
    this.modalCtrl.dismiss({bemerkung: this.bemerkung});
  }

  cancel() {
    this.modalCtrl.dismiss(null);
  }

  lieferbar(item: Artikel): boolean {
    if (this.artikelRes.nochNichtLieferbareAnzeigen) {
      return (new JsonDatePipe().transform(item.lieferbarAb) <= this.lieferdatum &&
              new JsonDatePipe().transform(item.lieferbarBis) >= this.lieferdatum);
    } else {
      return item.verfuegbar;
    }
  }
}
